module.exports = __webpack_public_path__ + "static/img/icon-2.87e96ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-2.png
// module id = ZQHk
// module chunks = 1 3 4 5 6 7